/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pricing_CtaInputs */

const en_cp_pricing_cta = /** @type {(inputs: Cp_Pricing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus program`)
};

const id_cp_pricing_cta = /** @type {(inputs: Cp_Pricing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program kampus`)
};

/**
* | output |
* | --- |
* | "Campus program" |
*
* @param {Cp_Pricing_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pricing_cta = /** @type {((inputs?: Cp_Pricing_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pricing_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pricing_cta(inputs)
	return en_cp_pricing_cta(inputs)
});